/**
 * Register vue and vuex components
 * @requires Vue vuejs
 * @requires Vuex state management
 */
import Vue from 'vue';
import Vuex from 'vuex';
import campaign from './modules/campaign';
import products from './modules/products';
import ecommerce from './modules/ecommerce';
import packages from './modules/packages';
import donations from './modules/donate';
import updates from './modules/update_details';
import loyalty from './modules/loyalty';
import popup from './modules/popup';
import sensis from './modules/sensis';
import search from './modules/search';
import earthHour from './modules/earth-hour';
import auth from './modules/auth';
import leafRelief from './modules/leaf-relief';
import amplitude from './modules/amplitude';
import kickbox from './modules/kickbox';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: false,
  modules: {
    campaign,
    product: products,
    packages,
    donation: donations,
    updates,
    loyalty,
    popup,
    sensis,
    search,
    earthHour,
    auth,
    leafRelief,
    ecommerce,
    amplitude,
    kickbox
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js